export default "__VITE_ASSET__a0d11573__"